import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.jsx';
import { Alert, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole, redirectTo = '/dashboard' }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // ou un loader
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si un rôle spécifique est requis
  if (requiredRole && user.role !== requiredRole) {
    console.warn(`🚫 Access denied: Required role "${requiredRole}", user has "${user.role}"`);
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </Alert>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;

